interface INavigationProps {
  url: string;
  identifier?: string;
}

export const handleNavigation = ({ url }: INavigationProps) => {
  window.location.href = url;
};
